import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Divider, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Material } from "../../../../../../types/Material";
import { MaterialInput } from "../../../../../items/components/MaterialInput";

type Props = {
  sources: string[];
  onChange?: (value: Material[]) => void;
  value?: Material[];
};

export const MaterialInputSelect = observer((props: Props) => {
  const t = useTranslation();
  const [items, setItems] = useState<Material[]>(props.value);
  const [newMaterial, setNewMaterial] = useState<Material>(undefined);
  const [open, setOpen] = useState(false);

  function addItem(e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) {
    e.preventDefault();
    setItems((prev) => {
      if (prev) {
        const existing = prev.find((item) => item.id === newMaterial.id);
        if (existing) {
          existing.quantity = newMaterial.quantity;
          return prev;
        }
        return [...prev, newMaterial];
      }
      return [newMaterial];
    });
    setNewMaterial(undefined);
  }

  useEffect(() => {
    props.onChange?.(items);
  }, [items]);

  useEffect(() => {
    if (props.value !== items) setItems(props.value);
  }, [props.value]);

  return (
    <Select
      size="small"
      open={open}
      options={items?.map((item) => ({
        label: `${item.name} (${item.quantity} ${item.unit})`,
        value: item.id,
      }))}
      value={items?.map((item) => item.id)}
      mode="multiple"
      style={{ minWidth: 200, height: 24 }}
      placeholder={t("maintenance:ticket.create.material.placeholder")}
      onDeselect={(id) => {
        setItems((prev) => prev.filter((item) => item.id !== id));
      }}
      onFocus={() => setOpen(true)}
      maxTagCount="responsive"
      popupRender={(menu) => (
        <>
          {menu}
          <Divider />
          <MaterialInput
            sources={props.sources}
            value={newMaterial}
            onChange={setNewMaterial}
          />
          <Button
            disabled={
              !newMaterial?.id ||
              !newMaterial?.quantity ||
              newMaterial.quantity === 0
            }
            icon={<Icon icon="fa:plus" />}
            onClick={addItem}
            style={{ width: "100%" }}
            variant="dashed"
          />
          <Divider />
          <Button
            onClick={() => setOpen(false)}
            style={{ width: "100%" }}
            variant="text"
          >
            {t("maintenance:global.button.close_label")}
          </Button>
        </>
      )}
    />
  );
});
